import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err, info) { console.error("[CoachIQ ErrorBoundary]", err, info); }
  reset = () => this.setState({ err: null });
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6" data-testid="error-boundary">
          <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center">
            <div className="w-14 h-14 rounded-2xl bg-red-50 mx-auto flex items-center justify-center mb-4 text-3xl">⚠️</div>
            <div className="font-display font-bold text-xl">Something went sideways</div>
            <div className="text-sm text-gray-500 mt-2">Don't worry — your data is safe. Try reloading, or head back to the dashboard.</div>
            <div className="mt-6 flex gap-2 justify-center">
              <button onClick={() => window.location.reload()} data-testid="err-reload" className="bg-[#007AFF] hover:bg-[#0056B3] text-white font-semibold rounded-full px-5 py-2.5">Reload</button>
              <button onClick={() => { this.reset(); window.location.href = "/dashboard"; }} data-testid="err-home" className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold rounded-full px-5 py-2.5">Go home</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
